export default "__VITE_ASSET__CcsnA99o__"